export default __webpack_public_path__ + "static/media/gallery_04.f490c34b.jpg";